import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import { useStyles } from "./UserDashboard.css";
import UserHeader from "../../../Components/NavBar/User/UserHeader/UserHeader";
import { connect } from "react-redux";
import TeacherDashboard from "./TeacherDashboard/TeacherDashboard";
import StudentDashboard from "./StudentDashboard/StudentDashboard";
import { getUserRefreshToken } from "../../../Redux/Actions/actions";
import PageTitle from "../../../Components/PageTitle/PageTitle";

class UserDashboard extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <UserHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <div className={classes.setionDesktop}>
            <PageTitle title="Dashboard" refreshUrl={this.props.match.url} />
          </div>
          {this.props.role === "Teacher" ? (
            <TeacherDashboard />
          ) : (
            <StudentDashboard />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(UserDashboard));
